import type { ExtraTab } from "@/components/Templates/types";
import LockIcon from "@/assets/icons/lock_hollow.svg?react";
import { FEATURE_FLAGS } from "@/utils/feature-flag-constants";
import { MapTab } from "../../MapTab";
import { MetricsTab } from "../../MetricsTab";

export const MAP_TAB_KEY = "map";
export const METRICS_TAB_KEY = "metrics";

const mapTab: ExtraTab = {
  type: "custom",
  key: MAP_TAB_KEY,
  title: "Map",
  icon: LockIcon,
  component: MapTab,
  toolbar: {
    showOnly: ["workspace", "filters", "guide"],
  },
};

const metricsTab: ExtraTab = {
  type: "custom",
  key: METRICS_TAB_KEY,
  title: "Metrics",
  icon: LockIcon,
  component: MetricsTab,
  toolbar: {
    showOnly: ["workspace", "filters", "guide"],
  },
};

/**
 * Map and Metrics are peers of Table in the Sites screen's view switcher, both
 * rendered from the same sites-overview payload. SITES_OVERVIEW_METRICS_HIDDEN
 * drops Metrics for tenants whose sites carry none of the numbers it sums — see
 * the flag's own comment for why it is removed rather than greyed out.
 *
 * DashboardTemplate validates the persisted screenView against the tabs it is
 * given, so a saved workspace left on Metrics falls back to Table rather than
 * rendering nothing.
 */
export const createSitesOverviewExtraTabs = (
  isFlagEnabled: (flag: string) => boolean = () => false,
): ExtraTab[] => {
  if (isFlagEnabled(FEATURE_FLAGS.SITES_OVERVIEW_METRICS_HIDDEN)) {
    return [mapTab];
  }
  return [mapTab, metricsTab];
};
